export const useShortItemId = (str?: string, separator: string = '/'): string | undefined => {
  if (!str) {
    return str
  }
  const split = str.split(separator)
  const last = split.pop()
  if (last) {
    return last
  }
  return str
}
